import type { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import type { Permissions } from '@/context/Permissions';
import { usePermissions } from '@/context/Permissions';

type ProtectedRouteProps = {
	permission: (p: Permissions) => boolean;
	children: ReactNode;
};

const NoAccess = () => {
	const { t } = useTranslation('translation', { keyPrefix: 'permissions' });

	return (
		<div className="flex min-h-screen items-center justify-center bg-white p-xl text-default">
			<div className="flex max-w-[420px] flex-col gap-xs text-center">
				<h1 className="text-[20px] font-semibold leading-tight">{t('NO_ACCESS_TITLE')}</h1>
				<p className="text-[13px] text-subtle">{t('NO_ACCESS_BODY')}</p>
			</div>
		</div>
	);
};

const ProtectedRoute: FC<ProtectedRouteProps> = ({ permission, children }) => {
	const { permissions } = usePermissions();

	if (!permission(permissions)) return <NoAccess />;
	return children;
};

export default ProtectedRoute;
